import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Event } from './../Event';

var debug = require('debug')('CRATE:Communication:MarkerManager:MarkerEvent');

export var MarkerEvent =
/*#__PURE__*/
function (_Event) {
  _inherits(MarkerEvent, _Event);

  function MarkerEvent(opts) {
    var _this;

    _classCallCheck(this, MarkerEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MarkerEvent).call(this, opts));
    _this._communicationChannel = _this._document._communication._behaviors_comm;
    _this._defaultOptions = {
      lifeTime: 5 * 1000,
      range: {
        index: 0,
        length: 0
      },
      cursor: false
    };
    return _this;
  }

  _createClass(MarkerEvent, [{
    key: "addMarker",
    value: function addMarker(id) {
      var isItMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.emit('addMarker', id, isItMe, opts);
    }
  }, {
    key: "removeMarker",
    value: function removeMarker() {}
  }]);

  return MarkerEvent;
}(Event);